
import { COLLECTION_ID_TO_ENDPOINT_NAME } from 'modules/collection/constants'

export default function getEndpointLoadRelatedProductUtil (featuredCollectionId) {
  const featuredCollectionEndpointName = COLLECTION_ID_TO_ENDPOINT_NAME?.[Number(featuredCollectionId)]
  return featuredCollectionEndpointName ? `collections/${featuredCollectionEndpointName}` : null
}
